var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chart',{staticClass:"patient-type-chart",attrs:{"options":_vm.chartOptions,"autoresize":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }